export default __webpack_public_path__ + "static/about-us-2-logo-82637fc8c498b584f51da119e1e7d112.png";